var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOclockG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6015 8C11.442 8 11.289 8.06329 11.1762 8.17595C11.0634 8.28861 11 8.44141 11 8.60074V11.6044C11 11.7637 11.0634 11.9165 11.1762 12.0292L12.9807 13.8314C13.0941 13.9408 13.246 14.0013 13.4037 14C13.5615 13.9986 13.7123 13.9354 13.8238 13.824C13.9354 13.7127 13.9986 13.562 14 13.4045C14.0013 13.247 13.9407 13.0952 13.8312 12.9819L12.203 11.3557V8.60074C12.203 8.44141 12.1396 8.28861 12.0268 8.17595C11.914 8.06329 11.761 8 11.6015 8Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.8333C15.2217 17.8333 17.8333 15.2217 17.8333 12C17.8333 8.77834 15.2217 6.16667 12 6.16667C8.77834 6.16667 6.16667 8.77834 6.16667 12C6.16667 15.2217 8.77834 17.8333 12 17.8333ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOclockG);
export default __webpack_public_path__ + "static/media/oclock_g.e29afcb66c03277c3af83c37c0f7859c.svg";
export { ForwardRef as ReactComponent };